<template>
  <div class="p_pro_content">
    <div class="topOperation">
      <div class="top-left">
        <div>
          <ShowNavHead />
        </div>
        <div class="screenInputs">
          <div class="screenInput">
            <div class="flname">项目名称</div>
            <el-input v-model="listQuery.projectname" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
          </div>
          <div class="screenInput">
            <div class="flname">项目ID</div>
            <el-input v-model="listQuery.projectid" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
          </div>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="更多检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">更多<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button type="success" size="small" @click="searchHandle" :style="'margin-right:' +((tableData.length>0) ? '8px':'16px')">搜索</el-button>
        <el-button v-if="checkPermission(['projectList_add'],permissionLists)" type="primary" size="small" @click="addHandle('false')" :style="'margin-right:' +((tableData.length>0)?'8px':'16px')">新增项目</el-button>
        <el-button v-if="(checkPermission(['projectList_export'],permissionLists) && this.tableData.length > 0)" type="warning" plain size="small" @click="exportHandle" :loading="btnLoading" :style="'margin-right:' +(tableData == []?'0':'16px')">导出</el-button>
      </div>
      <!-- 筛选下拉框 -->
      <div class="dropDownScreen" v-show="showDropScreen==1">
        <div class="pro_down_box">
          <el-form :inline="true" :model="listQuery" class="pro_down_form" label-width="120px">
            <el-form-item label="客户名称:">
              <el-input v-model="listQuery.custname" clearable></el-input>
            </el-form-item>
            <el-form-item label="业绩归属部门:">
              <el-cascader v-model="perDepartList" :props="props" clearable filterable :options="departList" @change="perSectionChange"></el-cascader>
            </el-form-item>
            <el-form-item label="合伙人:">
              <el-select v-model="listQuery.strpartner2" filterable clearable>
                <el-option v-for="(item, index) in partnerList" :key="index+'a'" :label="item.Username" :value="item.Userid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业绩归属人部门:">
              <el-cascader v-model="perOwnerList" :props="props" clearable filterable :options="departList" @change="ownerSectionChange"></el-cascader>
            </el-form-item>
            <el-form-item label="业绩归属人:" prop="strAchieveowner">
              <el-select v-model="listQuery.strAchieveowner" filterable clearable>
                <el-option v-for="(item, index) in memberList" :key="index+'b'" :label="item.Username" :value="item.Userid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业务团队长:">
              <el-select v-model="listQuery.strpartner" filterable clearable>
                <el-option v-for="(item, index) in leaderList" :key="index+'c'" :label="item.Username" :value="item.Userid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="服务部门:">
              <el-cascader v-model="dedpartNameList" :props="props" clearable filterable :options="departList" @change="handleSectionChange"></el-cascader>
            </el-form-item>
            <el-form-item label="客服:">
              <el-select v-model="listQuery.strservuserid" filterable clearable>
                <el-option v-for="(item, index) in customerList" :key="index+'d'" :label="item.Username" :value="item.Userid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="签约主体:">
              <el-select v-model="listQuery.strSignsubject" filterable clearable>
                <el-option v-for="(item, index) in legalList" :key="index+'e'" :label="item.StrLegalsubName" :value="item.Legalsubid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合同业务类型:">
              <el-select v-model="listQuery.strContractType" filterable clearable>
                <el-option v-for="(item, index) in businessList" :key="index+'f'" :label="item.StrBusitypeName" :value="item.Busitypeid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="实操业务类型:">
              <el-select v-model="listQuery.actualtype" filterable clearable>
                <el-option v-for="(item, index) in businessList" :key="index+'g'" :label="item.StrBusitypeName" :value="item.Busitypeid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="社保:">
              <el-select v-model="listQuery.socialInsuranceList" multiple clearable @change="socialChange">
                <el-option v-for="(item, index) in socialSecurityList" :key="index+'h'" :label="item.StrSocialsecName" :value="item.StrSocialsecName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商保:">
              <el-select v-model="listQuery.busInsuranceList" multiple clearable @change="busChange">
                <el-option v-for="(item, index) in insuranceList" :key="index+'j'" :label="item.StrBusisecName" :value="item.StrBusisecName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所在地区:">
              <el-cascader ref="regAddress" :props="propsAddress" v-model="regAddress" placeholder="" :options="provinces" clearable filterable @change="changeAddress" @clear="clearAddress"></el-cascader>
            </el-form-item>
            <!-- <el-form-item label="城市:">
              <el-input v-model="listQuery.strProCity" clearable></el-input>
            </el-form-item> -->
            <el-form-item label="发票类型:">
              <el-select v-model="listQuery.strBillmethod" clearable>
                <el-option label="专票" value="专票"></el-option>
                <el-option label="普票" value="普票"></el-option>
                <el-option label="专票+普票" value="专票+普票"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开票方式:">
              <el-select v-model="listQuery.strinvoiceType" clearable>
                <el-option label="全额" value="全额"></el-option>
                <el-option label="差额" value="差额"></el-option>
                <el-option label="全额+差额" value="全额+差额"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目等级:">
              <el-select v-model="listQuery.strprojectlevel" clearable>
                <el-option v-for="(item, index) in levelList" :key="index+'k'" :label="item.StrCustprolevelName" :value="item.Custprolevelid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属集团名称:">
              <el-input v-model="listQuery.groupname" clearable></el-input>
            </el-form-item>
            <el-form-item label="立项开始时间:">
              <el-date-picker v-model="listQuery.dtInitDatestart" clearable type="date" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="立项结束时间:">
              <el-date-picker v-model="listQuery.dtInitDateend" clearable type="date" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </div>
        <div class="drop-footer">
          <el-button size="small" plain @click="resetHandle()">清空</el-button>
          <el-button size="small" type="success" plain @click="searchHandle()">搜索</el-button>
          <el-button size="small" plain @click="showDropScreen=-1">关闭</el-button>
        </div>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>客户</el-breadcrumb-item>
          <el-breadcrumb-item>项目</el-breadcrumb-item>
          <el-breadcrumb-item>项目列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_cus_table" v-if="checkPermission(['projectList_page_list'],permissionLists)">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="全部" name="first"></el-tab-pane>
          <el-tab-pane label="合作中" name="second"></el-tab-pane>
          <el-tab-pane label="已暂停" name="third"></el-tab-pane>
          <el-tab-pane label="已终止" name="four"></el-tab-pane>
        </el-tabs>
        <el-table v-loading="tableLoading" :highlight-current-row="true" :max-height="tableHeight-100" :data="tableData" style="width:100%" stripe @current-change="chengebcg">
          <el-table-column align="center" label="项目ID" fixed width="60px">
            <template slot-scope="{row}">
              <span>{{row.Projectid}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目名称" fixed min-width="130px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrprojectName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="立项时间" min-width="100px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{!isNullDate(row.DtInitDate) ? row.DtInitDate.substring(0,10):''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目状态" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrBusiStat}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目终止时间" min-width="100px">
            <template slot-scope="{row}">
              <span>{{isNullDate(row.DtEndDate) ? '' : row.DtEndDate.substring(0,10)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="客户ID" width="60px">
            <template slot-scope="{row}">
              <span>{{row.Custid}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="客户简称" min-width="150px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrCustShortName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="客户名称" min-width="280px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrCustName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="所属集团名称" min-width="130px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.strGroupName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="实操业务类型" min-width="150px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.ActualtypeName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目等级">
            <template slot-scope="{row}">
              <span>{{row.StrCustprolevelName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="所在地区" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrRegion}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="项目城市">
            <template slot-scope="{row}">
              <span>{{row.StrProCity}}</span>
            </template>
          </el-table-column> -->
          <el-table-column align="center" label="业绩归属部门" min-width="200px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrbusdepName}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="业绩归属子部门" min-width="130px">
            <template slot-scope="{row}">
              <span>{{row.StrbussondepName}}</span>
            </template>
          </el-table-column> -->
          <el-table-column align="center" label="业务团队长" min-width="130px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrpartnerName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="合伙人" min-width="130px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrpartnerName2}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="业绩归属人部门" min-width="200px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrAchievedepName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="业绩归属人" min-width="100px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrAchieveownerName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="一级部门" min-width="100px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrDep1Name}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="二级部门" min-width="100px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrDep2Name}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="三级部门" min-width="100px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrDep3Name}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="客服" min-width="100px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrservuseridName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目管理员" min-width="100px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrProManagerName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="是否招聘">
            <template slot-scope="{row}">
              <span>{{row.Strrecruit}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="是否转移">
            <template slot-scope="{row}">
              <span>{{row.StrTransfer}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="协议高风险" min-width="120px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrHighRisk}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="是否新增">
            <template slot-scope="{row}">
              <span>{{row.StrNewadd}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="社保" min-width="130px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.SocialInsurance}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="商保" min-width="140px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.BusInsurance}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="计提风险金" min-width="100px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.DecRiskfund}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="发票类型" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrBillmethod}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="开票方式" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrinvoiceType}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="开票内容" min-width="180px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrInvoicecontent}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="发薪日期" min-width="120px">
            <template slot-scope="{row}">
              <span>{{!isNullDate(row.Dtpaydate)?row.Dtpaydate.substring(0,10):''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="是否垫资">
            <template slot-scope="{row}">
              <span>{{row.IsAdvMoney}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="签约主体" min-width="230px">
            <template slot-scope="{row}">
              <el-tooltip class="item" effect="dark" :content="row.StrSignsubjectName" placement="top">
                <span class="sub_txt" :style="{color: row.isHighlight ? '#fff' : '#409EFF'}" title="点击可查看具体信息" @click="dtlSubInfo(row.StrSignsubjectNameall)">{{row.StrSignsubjectName}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="合同业务类型" min-width="130px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrContractTypeName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="合同起始时间" min-width="120px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{!isNullDate(row.DtContractstartDate)?row.DtContractstartDate.substring(0,10):''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="合同到期时间" min-width="120px">
            <template slot-scope="{row}">
              <span>{{!isNullDate(row.DtContractendDate)?row.DtContractendDate.substring(0,10):''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="合同负责人" min-width="120px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrContleaderName}}</span>
            </template>
          </el-table-column> -->
          <el-table-column align="center" label="到期前60天提醒" min-width="130px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span style="color:#F56C6C;">{{isOverdue(60, row.StrRemind60, row.DtContractendDate)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="创建时间" min-width="120px">
            <template slot-scope="{row}">
              <span>{{!isNullDate(row.DtInsertDate)?row.DtInsertDate.substring(0,10):''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目查看人" min-width="160px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrViewidsName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="客户人员" min-width="140px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrCustomeridName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" fixed="right" :width="checkPermission(['projectList_edit'],permissionLists)||checkPermission(['projectList_state'],permissionLists)||checkPermission(['projectList_cusService'],permissionLists)?'330px':'180px'">
            <template slot-scope="{row}">
              <el-button v-if="checkPermission(['projectList_edit'],permissionLists)" type="primary" size="mini" plain @click="editHandle(row, 'true')">编辑</el-button>
              <el-button v-if="checkPermission(['projectList_acSet'],permissionLists) && !checkPermission(['projectList_edit'],permissionLists)" type="primary" size="mini" plain @click="editAcSetHandle(row, 'true')">编辑</el-button>
              <el-button v-if="checkPermission(['projectList_state'],permissionLists)" type="warning" size="mini" plain @click="stateHandle(row)">修改状态</el-button>
              <el-button v-if="checkPermission(['projectList_cusService'],permissionLists)" type="primary" size="mini" @click="editCusHandle(row)">负责客服</el-button>
              <el-button type="success" size="mini" plain @click="detailHandle(row, 'detail')">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination @current-change="changeBPage" :current-page.sync="listQuery.currpage" :page-size="listQuery.perpage" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev,pager,next,jumper" :total="total"></el-pagination>
        </div>
      </div>
    </div>
    <!-- 修改状态弹框 -->
    <el-dialog title="修改状态" :visible.sync="proVisible" width="600px" class="cus_dialog">
      <el-form :model="proForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="项目状态:" prop="strBusiStat">
          <el-select v-model="proForm.strBusiStat" placeholder="请选择项目状态">
            <el-option label="合作中" value="合作中"></el-option>
            <el-option label="已暂停" value="已暂停"></el-option>
            <el-option label="已终止" value="已终止"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目终止时间:">
          <el-radio-group v-model="proEndDate">
            <el-radio :label="0">无日期</el-radio>
            <el-radio :label="1">选择终止时间</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="" v-if="proEndDate == '1'">
          <el-date-picker v-model="proForm.dtEndDate" type="date" value-format="yyyy-MM-dd" placeholder="选择项目终止时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="proVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="saveStateHandle('ruleForm')" size="small">保存</el-button>
      </span>
    </el-dialog>
    <!-- 修改客服弹框 -->
    <el-dialog title="负责客服" :visible.sync="cusVisible" width="600px" class="cus_dialog">
      <el-form :model="editCusQuery" label-width="100px" class="demo-ruleForm">
        <el-form-item label="负责客服:" prop="strservuserid">
          <el-select v-model="editCusVal" filterable multiple clearable @change="updateCusChange" style="width:300px;margin-right:8px;">
            <el-option v-for="(item, index) in custList" :key="index+'t'" :label="item.Username" :value="item.Userid">
            </el-option>
          </el-select>
          <el-button @click="unbindHandle" type="success" plain>解绑客服</el-button>
        </el-form-item>
        <el-form-item label="" v-if="selServiceList.length>0">
          <div class="error_txt">
            <div v-for="(item, index) in selServiceList" :key="index+'s'" class="error_item">
              <p>温馨提示:{{item}}客服非您负责区域的客服人员,请确认！</p>
              <i class="el-icon-close" @click="dltErrorHandle(index)"></i>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cusVisible = false" size="small">取消</el-button>
        <el-popconfirm confirm-button-text='确定' icon="el-icon-info" icon-color="red" v-if="isNullDate(editCusVal)" @confirm="saveCusHandle" title="请确认是否解绑客服？">
          <el-button slot="reference" class="pinkButton" type="primary" size="small" style="margin-left: 10px;">保存</el-button>
        </el-popconfirm>
        <el-button v-if="!isNullDate(editCusVal)" type="primary" @click="saveCusHandle" size="small">保存</el-button>
      </span>
    </el-dialog>
    <!-- 签约主体信息 -->
    <el-dialog title="签约主体信息" :visible.sync="subVisible" width="800px" class="cus_dialog">
      <el-table :data="subData" style="width:100%">
        <el-table-column align="center" label="签约主体" fit show-overflow-tooltip fixed width="120px">
          <template slot-scope="{row}">
            <span>{{row.StrSignsubjectName}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="合同业务类型" fit show-overflow-tooltip min-width="100px">
          <template slot-scope="{row}">
            <span>{{row.StrBusitypeName}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="合同负责人" fit show-overflow-tooltip min-width="100px">
          <template slot-scope="{row}">
            <span>{{row.StrContleaderName}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="合同开始时间" fit show-overflow-tooltip min-width="100px">
          <template slot-scope="{row}">
            <span>{{row.DtContractstartDate?row.DtContractstartDate.substring(0,10):''}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="合同结束时间" fit show-overflow-tooltip min-width="100px">
          <template slot-scope="{row}">
            <span>{{row.DtContractendDate?row.DtContractendDate.substring(0,10):''}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="合同附件" fit show-overflow-tooltip min-width="100px">
          <template slot-scope="{row}">
            <div v-for="(item,index) in row.contractList" :key="index" @click="downHandle(item)" class="f_txt">{{item.name}}</div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="subVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "@/common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import moment from 'moment'
  export default {
    name: "serviceCenter",
    data() {
      return {
        // 选中的负责客服人员列表
        selServiceList: [],
        cusVisible: false,
        btnLoading: false,
        activeName: 'first',
        dialogTitle: '新增项目',
        proVisible: false,
        custList: [],
        // 列表参数
        listQuery: {
          projectname: '', // 项目名称
          projectid: '', // 项目id
          custname: '', //客户名称
          strbusdep: '', //业绩归属部门
          strpartner2: '', //合伙人
          strDep1: '', //部门一级
          strDep2: '', //部门二级
          strDep3: '', //部门三级
          strservuserid: '', //客服
          strContractType: '', //合同业务类型
          actualtype: '', //实操业务类型
          strSignsubject: '', //签约主体
          socialInsurance: '', //社保
          socialInsuranceList: [], //社保多选
          busInsurance: '',
          busInsuranceList: [], //商保
          strProProvince: '', //省份
          strProCity: '', //城市
          strBillmethod: '', //发票类型
          strinvoiceType: '', //开票方式
          strprojectlevel: '', //项目等级
          groupname: '', //所属集团名称
          strBusiStat: '', //项目状态
          perpage: 10,
          currpage: 1,
          strorgancode: '',
          roletype: '',
          strpartner: '', // 团队长
          dtInitDatestart: '', // 立项开始时间
          dtInitDateend: '', // 立项结束时间
          strAchieveowner: '', // 业绩归属人
          strAchievedep: '' //业绩归属人部门
        },
        // 业绩归属人部门
        perOwnerList: [],
        // 部门列表
        departList: [],
        // 合伙人
        partnerList: [],
        // 客服
        customerList: [],
        // 服务部门
        dedpartNameList: [],
        // 合同业务类型
        businessList: [],
        // 选中的业绩归属部门
        perDepartList: [],
        // 业绩归属人
        memberList: [],
        // 业务团队长列表
        leaderList: [],
        // 签约主体列表
        legalList: [],
        // 社保
        socialSecurityList: [],
        // 商保
        insuranceList: [],
        //项目等级
        levelList: [],
        // 导出参数
        exportQuery: {
          projectname: '', // 项目名称
          projectid: '', // 项目id
          custname: '', //客户名称
          strbusdep: '', //业绩归属部门
          strpartner2: '', //合伙人
          strDep1: '', //部门一级
          strDep2: '', //部门二级
          strDep3: '', //部门三级
          strservuserid: '', //客服
          strContractType: '', //合同业务类型
          actualtype: '', //实操业务类型
          strSignsubject: '', //签约主体
          socialInsurance: '', //社保
          busInsurance: '',
          strProProvince: '', //省份
          strProCity: '', //城市
          strArea: '',
          strBillmethod: '', //发票类型
          strinvoiceType: '', //开票方式
          strprojectlevel: '', //项目等级
          groupname: '', //所属集团名称
          strBusiStat: '', //项目状态
          strorgancode: '',
          roletype: '',
          perpage: 10000000,
          currpage: 1,
          tableid: 'JB_base_Project_out',
          strpartner: '', // 团队长
          dtInitDatestart: '', // 立项开始时间
          dtInitDateend: '', // 立项结束时间
          strAchieveowner: '', // 业绩归属人
          strAchievedep: '' //业绩归属人部门
        },
        // 参数列表参数
        paramQuery: {
          currpage: 1,
          perpage: 100000,
          keyword: '',
          strIsDisable: '', // 传1 禁用的看不到了  不传就全显示
          // JB_base_Busitype 业务类型 JB_base_Custprolevel客户项目等级 
          // JB_base_Jobfunclabel 岗位职能标签 JB_base_Socialsec社保 JB_base_Busisec 商保
          strtableid: ''
        },
        tableHeight: 0,
        regAddress: '',
        tableLoading: false,
        rules: {
          strBusiStat: [{
            required: true,
            message: '请选择项目状态',
            trigger: 'change'
          }]
        },
        tableData: [],
        total: 0,
        //下拉筛选
        showDropScreen: -1,
        // 项目状态参数
        proForm: {
          projectid: '',
          strBusiStat: '',
          dtEndDate: ''
        },
        // 部门参数
        departQuery: {
          strorgancode: '',
          roletype: ''
        },
        // 业务部门员工参数
        oneDepartQuery: {
          strorgancode: '',
          roletype: ''
        },
        // 弹框员工参数
        oneDialogQuery: {
          strorgancode: '',
          roletype: ''
        },
        // 员工参数
        departMemberQuery: {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "",
          strstation: "",
          strorgancode: ""
        },
        depMemberQuery: {
          currpage: 1,
          perpage: 10000,
          strWorkState: '在职',
          keyword: ''
        },
        // 自定义 级联选择props
        props: {
          label: 'strorganname',
          value: 'strorgancode',
          children: 'children',
          checkStrictly: true
        },
        // 按钮权限参数
        butQuery: {
          path: '/projectList',
          powerEnName: 'projectManage'
        },
        // 是否有权限操作按钮
        isCanHandle: false,
        //项目终止时间
        proEndDate: 0,
        // 是否是合伙人
        isPartner: '',
        // 按钮权限
        permissionLists: [],
        // 是否可导出
        isExport: false,
        // 修改客服参数
        editCusQuery: {
          projectid: '',
          strservuserid: '',
          strUserName: '',
          roletype: ''
        },
        editCusVal: [],
        subData: [],
        subVisible: false,
        docPath: this.$store.state.EMP.docPath,
        provinces: [],
        propsAddress: {
          label: "Name",
          value: "Name",
          children: "children",
          checkStrictly: true
        },
      }
    },
    created() {
      this.listQuery.roletype = localStorage.loginRoletype
      this.editCusQuery.roletype = localStorage.loginRoletype
      this.listQuery.strorgancode = localStorage.gancode
      this.oneDialogQuery.strorgancode = localStorage.gancode
      this.oneDialogQuery.roletype = localStorage.loginRoletype
      this.isPartner = localStorage.isPartner
      this.getprovinces()
      // this.departQuery.roletype = localStorage.loginRoletype
      // this.departQuery.strorgancode = localStorage.gancode
      this.getButtonPower()
      // 获取部门列表
      this.getDepartList()
      // 客户项目等级
      this.getParamList('JB_base_Custprolevel')
      // 业务类型
      this.getParamList('JB_base_Busitype')
      // 社保
      this.getParamList('JB_base_Socialsec')
      // 商保
      this.getParamList('JB_base_Busisec')
      // 签约主体
      this.getParamList('JB_base_Legalsub')
      // 业绩归属人
      this.getMemberList('member')
      // 合伙人
      this.getMemberList('partner')
      // 团队长
      this.getMemberList('leader')
      // 客服
      this.getCusList('customer')
      this.getMemberList('service')
      this.calHeight()
    },
    methods: {
      checkPermission,
      //切换tab
      async handleClick(tab, event) {
        // console.log('tab',tab, event)
        if (tab.label == '全部') {
          this.listQuery.strBusiStat = ''
        } else {
          this.listQuery.strBusiStat = tab.label
        }
        this.listQuery.currpage = 1
        this.getList()
      },
      //获取省市区
      getprovinces() {
        xz.getAreaAll().then((res) => {
          this.provinces = res
        })
      },
      changeAddress(val) {
        this.listQuery.RegisteredAddress = val.toString();
        if (val.length == 3) {
          this.listQuery.strProProvince = val[0];
          this.listQuery.strProCity = val[1];
          this.listQuery.strArea = val[2];
        } else if (val.length == 2) {
          this.listQuery.strProProvince = val[0];
          this.listQuery.strProCity = val[1];
          this.listQuery.strArea = '';
        } else if (val.length == 1) {
          this.listQuery.strProProvince = val[0];
          this.listQuery.strProCity = '';
          this.listQuery.strArea = '';
        }
        this.$refs.regAddress._data.dropDownVisible = false;
      },
      clearAddress() {
        this.listQuery.strProProvince = '';
          this.listQuery.strProCity = '';
          this.listQuery.strArea = '';
      },
      isNullDate(o) {
        // console.log('isnull',o)
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == '1900/01/01' || o == '1900-01-01T00:00:00' || o == '1900-01-01'
      },
      // 下载附件
      downHandle(row) {
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = this.docPath + row.url;
        link.setAttribute('download', row.name); //这里写保存时的文件名称
        document.body.appendChild(link);
        link.click()
        // console.log('dd',row)
      },
      // 查看主体信息
      dtlSubInfo(data) {
        let that = this
        this.subData = data;
        if (this.subData && this.subData.length > 0) {
          for (let i = 0; i < that.subData.length; i++) {
            let elements = that.subData[i];
            that.$set(elements, "contractList", (elements.StrContractatta ? JSON.parse(elements.StrContractatta) : []));
          }
        }
        this.subVisible = true
      },
      // 修改客服弹窗
      editCusHandle(item) {
        // console.log('isnull', item)
        this.selServiceList = []
        this.editCusQuery.projectid = item.Projectid
        this.editCusQuery.strservuserid = item.Strservuserid
        // this.editCusQuery.strUserName = item.StrservuseridName
        if (!this.isNullDate(item.Strservuserid)) {
          // 去重
          let arr1 = item.Strservuserid.split(',')
          this.editCusVal = [...new Set(arr1)];
          this.rankHandle(this.editCusVal[Number(this.editCusVal.length) - 1])
        }
        this.cusVisible = true
      },
      // 解绑客服
      unbindHandle() {
        this.editCusVal = []
        this.editCusQuery.strservuserid = ''
        this.editCusQuery.strUserName = ''
        this.selServiceList = []
      },
      updateCusChange(val) {
        // console.log('updateCusChange', val)
        if (this.isNullDate(val)) {
          this.editCusVal = []
          this.editCusQuery.strservuserid = ''
          this.editCusQuery.strUserName = ''
        } else {
          this.editCusQuery.strservuserid = val.toString()
          this.rankHandle(val[Number(val.length) - 1])
          // this.editCusQuery.strUserName = val.label
        }
      },
      // 判断是否是登录人员的上下级
      rankHandle(checkuserid) {
        xz.checkProStrservuserid(checkuserid).then(res => {
          if (res.status == 'ok') {
            if (res.msg == 'false') {
              this.selServiceList.push(res.username)
            }
            this.selServiceList = [...new Set(this.selServiceList)]
          }
        })
      },
      // 删除错误提示
      dltErrorHandle(currindex) {
        // let currindex = this.selServiceList.indexOf(item)
        // if(currindex >-1){
        this.selServiceList.splice(currindex, 1)
        // }
      },
      // 确定修改客服
      saveCusHandle() {
        // if(this.isNullDate(this.editCusQuery.strservuserid)){
        //   this.$message({
        //     message: "请选择客服",
        //     type: "warning"
        //   })
        //   return false
        // }
        // console.log('saveCusHandle', this.editCusQuery)
        xz.updateProService(this.editCusQuery).then(res => {
          if (res.status == 'ok') {
            this.$message({
              message: "修改成功",
              type: "success"
            })
            this.cusVisible = false
            this.getList()
          } else {
            this.$message({
              message: "修改失败，请稍后再试",
              type: "error"
            })
          }
        })
      },
      // 是否可导出
      isExports() {
        // console.log('tab',this.isCanHandle)
        return this.isCanHandle || (localStorage.loginRoletype == 'branch') || (localStorage.loginRoletype == 'business') || (this.isPartner == '是') || (localStorage.loginRoletype == 'manager')
      },
      // 业绩归属人部门选择
      ownerSectionChange(val) {
        // console.log('业绩归属人部门', val)
        // this.departQuery.strorgancode = val[Number(val.length)-1]
        // this.departQuery.roletype = localStorage.loginRoletype
        // this.getMemberList('member')
        if (this.isNullDate(val)) {
          this.listQuery.strAchievedep = ''
        } else {
          this.listQuery.strAchievedep = val[Number(val.length) - 1]
        }
      },
      // 提醒判断
      isOverdue(num, data, endDate) {
        let timeNow = moment().format("YYYY-MM-DD")
        let timeEnd = moment(endDate).format("YYYY-MM-DD")
        // console.log('ppp', timeEnd)
        if ((Number(data) < num) && (Number(data) > 0) && (!this.isNullDate(endDate))) {
          return '还有' + data + '天到期'
        }
        if (Number(data) < 0 && (!this.isNullDate(endDate))) {
          return '已过期'
        }
        if (timeEnd == timeNow) {
          return '已到期'
        }
        if (Number(data) > num || Number(data) == 0) {
          return ''
        }
      },
      // 获取按钮权限
      getButtonPower() {
        let that = this
        xz.getbtnPowerIdBypage(this.butQuery).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
              if (that.checkPermission(['projectList_page_list'], that.permissionLists)) {
                that.getList()
              }
            } else {
              this.permissionLists = []
            }
          } else {
            this.permissionLists = []
          }
        })
      },
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
        console.log('height', this.tableHeight)
      },
      // 导出
      exportHandle() {
        this.btnLoading = true
        this.exportQuery.projectname = this.listQuery.projectname
        this.exportQuery.projectid = this.listQuery.projectid
        this.exportQuery.custname = this.listQuery.custname
        this.exportQuery.strbusdep = this.listQuery.strbusdep
        this.exportQuery.strBusiStat = this.listQuery.strBusiStat
        this.exportQuery.strpartner2 = this.listQuery.strpartner2
        this.exportQuery.strDep1 = this.listQuery.strDep1 //部门一级
        this.exportQuery.strDep2 = this.listQuery.strDep2 //部门二级
        this.exportQuery.strDep3 = this.listQuery.strDep3 //部门三级
        this.exportQuery.strservuserid = this.listQuery.strservuserid
        this.exportQuery.strContractType = this.listQuery.strContractType
        this.exportQuery.actualtype = this.listQuery.actualtype
        this.exportQuery.strSignsubject = this.listQuery.strSignsubject
        this.exportQuery.socialInsurance = this.listQuery.socialInsurance
        this.exportQuery.busInsurance = this.listQuery.busInsurance
        this.exportQuery.strProProvince = this.listQuery.strProProvince
        this.exportQuery.strProCity = this.listQuery.strProCity
        this.exportQuery.strBillmethod = this.listQuery.strBillmethod
        this.exportQuery.strinvoiceType = this.listQuery.strinvoiceType
        this.exportQuery.strprojectlevel = this.listQuery.strprojectlevel
        this.exportQuery.groupname = this.listQuery.groupname
        this.exportQuery.strorgancode = this.listQuery.strorgancode
        this.exportQuery.roletype = this.listQuery.roletype
        this.exportQuery.strpartner = this.listQuery.strpartner
        this.exportQuery.dtInitDatestart = this.listQuery.dtInitDatestart
        this.exportQuery.dtInitDateend = this.listQuery.dtInitDateend
        this.exportQuery.strAchieveowner = this.listQuery.strAchieveowner
        this.exportQuery.strAchievedep = this.listQuery.strAchievedep
        xz.getOutProjectLists(this.exportQuery).then(res => {
          // console.log('导出', res)
          if (res.status == 'ok') {
            this.$router.push({
              path: "/exportList",
              query: {
                showPage: 1,
                isActive: 1,
                custname: res.msg,
                //qStstus=1时查看最后一条导出记录
                qStstus: 1
              }
            })
          } else {
            this.$message({
              message: "导出失败，请稍后再试",
              type: "error"
            })
          }
          this.btnLoading = false
        })
      },
      // 搜索
      searchHandle() {
        this.listQuery.currpage = 1
        if (!this.isNullDate(this.listQuery.busInsuranceList)) {
          this.listQuery.busInsurance = this.listQuery.busInsuranceList.toString()
        }
        if (!this.isNullDate(this.listQuery.socialInsuranceList)) {
          this.listQuery.socialInsurance = this.listQuery.socialInsuranceList.toString()
        }
        this.showDropScreen = -1
        this.getList()
      },
      // 修改社保
      socialChange(val) {
        // console.log('kkk', val)
        if (this.isNullDate(val)) {
          this.listQuery.socialInsuranceList = []
          this.listQuery.socialInsurance = ''
        } else {
          this.listQuery.socialInsuranceList = val
          this.listQuery.socialInsurance = val.toString()
        }
      },
      // 修改商保
      busChange(val) {
        if (this.isNullDate(val)) {
          this.listQuery.busInsuranceList = []
          this.listQuery.busInsurance = ''
        } else {
          this.listQuery.busInsuranceList = val
          this.listQuery.busInsurance = val.toString()
        }
      },
      // 业绩归属部门选择
      perSectionChange(val) {
        // console.log('业绩归属部门', val)
        if (this.isNullDate(val)) {
          this.listQuery.strbusdep = ''
        } else {
          this.listQuery.strbusdep = val[Number(val.length) - 1]
        }
        // this.departQuery.strorgancode = val[Number(val.length)-1]
        // this.departQuery.roletype = localStorage.loginRoletype
        // this.getMemberList('partner')
      },
      // 查看
      detailHandle(item, type) {
        this.$router.push({
          path: '/addProject',
          query: {
            isEdit: type,
            projectid: item.Projectid
          }
        })
      },
      //分页
      changeBPage(val) {
        this.listQuery.currpage = Number(val)
        this.getList()
      },
      handleSizeChange(val) {
        this.listQuery.currpage = 1
        this.listQuery.perpage = Number(val)
        this.getList()
      },
      // 编辑客户
      editHandle(item, type) {
        this.$router.push({
          path: '/addProject',
          query: {
            isEdit: type,
            projectid: item.Projectid
          }
        })
      },
      //编辑账套信息
      editAcSetHandle(item) {
        this.$router.push({
          path: '/acSet',
          query: {
            projectid: item.Projectid
          }
        })
      },
      //新增弹窗
      addHandle(type) {
        this.$router.push({
          path: '/addProject',
          query: {
            isEdit: type
          }
        })
      },
      // 修改状态弹窗
      stateHandle(item) {
        this.proForm.projectid = item.Projectid
        this.proForm.strBusiStat = item.StrBusiStat
        if (!this.isNullDate(item.DtEndDate)) {
          this.proEndDate = 1
        } else {
          this.proEndDate = 0
        }
        this.proForm.dtEndDate = item.DtEndDate
        this.proVisible = true
        console.log('item', item)
      },
      //确定修改状态
      saveStateHandle(formName) {
        if (this.proEndDate == 0) {
          this.proForm.dtEndDate = '1900-01-01'
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            xz.updateProStatue(this.proForm).then(res => {
              if (res.status == 'ok') {
                this.$message({
                  message: "修改成功",
                  type: "success"
                })
                this.proVisible = false
                this.getList()
              } else {
                this.$message({
                  message: "修改失败，请稍后再试",
                  type: "error"
                })
              }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      // 服务部门选择
      handleSectionChange(value) {
        this.listQuery.strservuserid = ''
        // console.log(value)
        if (value.length >= 3) {
          this.listQuery.strDep1 = value[0]
          this.listQuery.strDep2 = value[1]
          this.listQuery.strDep3 = value[2]
        }
        if (value.length == 2) {
          this.listQuery.strDep1 = value[0]
          this.listQuery.strDep2 = value[1]
          this.listQuery.strDep3 = ''
        }
        if (value.length == 1) {
          this.listQuery.strDep1 = value[0]
          this.listQuery.strDep2 = ''
          this.listQuery.strDep3 = ''
        }
        if (this.isNullDate(value)) {
          this.listQuery.strDep1 = ''
          this.listQuery.strDep2 = ''
          this.listQuery.strDep3 = ''
        }
        // this.departQuery.strorgancode = value[Number(value.length)-1]
        // this.departQuery.roletype = localStorage.loginRoletype
        // this.getCusList('customer')
      },
      // 获取客服列表
      getCusList(type) {
        xz.getauthUserInfoByorgancode(this.depMemberQuery).then(res => {
          // console.log('员工', res)
          if (res.status == 'ok') {
            if (type == 'customer') {
              this.customerList = res.msg
            } else {
              // 客服列表
              this.customerList = []
            }
          }
        })
      },
      getDialogCusList(type) {
        xz.getauthUserInfoByorgancode(this.oneDialogQuery.strorgancode, this.oneDialogQuery.roletype, this.depMemberQuery).then(res => {
          // console.log('员工', res)
          if (res.status == 'ok') {
            if (type == 'customer') {
              this.custList = res.msg
            } else {
              // 客服列表
              this.custList = []
            }
          }
        })
      },
      chengebcg(currentRow, oldCurrentRow) {
        console.log(currentRow, oldCurrentRow)
        this.$set(currentRow, 'isHighlight', true);
        if (oldCurrentRow != undefined) {
          this.$set(oldCurrentRow, 'isHighlight', false)
        }
      },
      // 获取员工列表
      getMemberList(type) {
        if (type == 'service') {
          this.departMemberQuery.strWorkState = '在职'
        } else {
          this.departMemberQuery.strWorkState = ''
        }
        xz.getauthUserInfoByorgancode(this.departMemberQuery).then(res => {
          // console.log('员工', res)
          if (res.status == 'ok') {
            if (type == 'partner') {
              // 合伙人列表
              this.partnerList = res.msg
            } else if (type == 'member') {
              this.memberList = res.msg
            } else if (type == 'leader') {
              // 业务团队长列表
              this.leaderList = res.msg
            } else if (type == 'service') {
              // 负责客服列表
              this.custList = res.msg
            }
          } else {
            if (type == 'partner') {
              // 合伙人列表
              this.partnerList = []
            } else if (type == 'member') {
              this.memberList = []
            } else if (type == 'leader') {
              // 业务团队长列表
              this.leaderList = []
            } else if (type == 'service') {
              // 负责客服列表
              this.custList = []
            }
          }
        })
      },
      // 获取参数列表(等级)
      getParamList(type) {
        this.paramQuery.strtableid = type
        xz.getParameterList(this.paramQuery).then(res => {
          // console.log('参数', res)
          if (res.status == 'ok') {
            // 客户项目等级
            if (type == 'JB_base_Custprolevel') {
              this.levelList = res.msg
            } else if (type == 'JB_base_Busitype') {
              // 业务类型
              this.businessList = res.msg
            } else if (type == 'JB_base_Socialsec') {
              // 社保
              this.socialSecurityList = res.msg
            } else if (type == 'JB_base_Busisec') {
              // 商保
              this.insuranceList = res.msg
            } else if (type == 'JB_base_Legalsub') {
              // 签约主体
              this.legalList = res.msg
            }
          } else {
            if (type == 'JB_base_Custprolevel') {
              this.levelList = []
            } else if (type == 'JB_base_Busitype') {
              // 业务类型
              this.businessList = []
            } else if (type == 'JB_base_Socialsec') {
              // 社保
              this.socialSecurityList = []
            } else if (type == 'JB_base_Busisec') {
              // 商保
              this.insuranceList = []
            } else if (type == 'JB_base_Legalsub') {
              // 签约主体
              this.legalList = []
            }
          }
        })
      },
      // 获取项目列表
      getList() {
        this.tableLoading = true
        xz.getProjectListsversion1(this.listQuery).then(res => {
          // console.log('客户', res)
          if (res.status == 'ok') {
            this.tableData = res.msg
            this.total = res.totalcount
          } else {
            this.tableData = []
            this.total = 0
          }
          this.tableLoading = false
        })
      },
      // 获取部门列表
      getDepartList() {
        xz.getorganstr(this.departQuery.strorgancode, this.departQuery.roletype, {
          strIsDisable: ''
        }).then(res => {
          // console.log('部门', res)
          if (res.status == 'ok') {
            if (res.msg && res.msg.parent) {
              this.departList = res.msg.parent[0].children
            }
          } else {
            this.departList = []
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0
      },
      //清空
      resetHandle() {
        this.listQuery = this.$options.data.call(this).listQuery
        this.listQuery.strorgancode = localStorage.gancode
        this.listQuery.roletype = localStorage.loginRoletype
        this.perDepartList = []
        this.dedpartNameList = []
        this.perOwnerList = []
      }
    }
  };
</script>
<style>
  .p_pro_content .el-table .el-table__cell {
    padding: 5px 0 !important;
  }

  .p_pro_content .top-right .el-button+.el-button {
    margin-left: 0;
  }

  .scr_icon .el-icon-caret-bottom {
    font-size: 18px;
    color: #999;
    cursor: pointer;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .pro_down_form {
    margin-top: 8px;
  }

  .pro_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .pro_down_form .el-input__inner {
    height: 32px !important;
    line-height: 32px !important;
  }

  .pro_down_form .el-select,
  .pro_down_form .el-cascader,
  .pro_down_form.el-form--inline .el-form-item__content,
  .pro_down_form .el-date-editor.el-input {
    width: 209px;
  }

  .p_pro_content .screenInput .el-input {
    width: 200px;
  }

  .cus_dialog .el-date-editor.el-input,
  .cus_dialog .el-select {
    width: 100%;
  }

  .cus_dialog .el-form--inline .el-form-item__content {
    width: 250px;
  }

  .p_cus_table .el-tabs {
    background-color: #fff;
  }
</style>
<style scoped>
  .f_txt {
    font-size: 13px;
    color: #333;
    margin-top: 3px;
    cursor: pointer;
    text-decoration: underline;
  }

  .sub_txt {
    color: #409EFF;
    /* font-weight: bold; */
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .error_item {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 3px;
  }

  .error_item p {
    /* flex:1; */
    font-size: 13px;
    line-height: 20px;
    color: #999;
  }

  .error_item i {
    font-size: 14px;
    color: #ddd;
    margin-left: 5px;
    font-weight: bold;
    cursor: pointer;
  }

  .el-pagination {
    background-color: #fff;
  }

  .reset {
    height: 32px;
    padding: 5px 15px;
    border-radius: 5px;
    color: #B2BCB7;
    background-color: #fff;
    border: 1px solid #fff;
    margin-right: 10px;
  }

  .p-txt {
    color: rgba(0, 0, 0, 0.4);
  }
</style>